import $ from 'jQuery';

export default function () {

  $(function() {
    bio_expand();
  });

  function bio_expand() {
		$('.bio-expand').on('click', function() {
			if ( !$(this).parents('.people-list--item').hasClass('active') ) {
				$(this).parents('.people-list--items').find('.people-list--item.active .bio-collapse').trigger('click');
			}

		  $('.' + $(this).attr('data-target'))
		  	.css('padding-top', $(this).parent().height() - 56)
		  	.slideToggle(300);

		  $(this).parents('.people-list--item').css('z-index', '2')
		  	.addClass('active');
		});

		$('.people-list--item').on('click', '.people-list--bio .bio-collapse', function() {
		  $('.' + $(this).attr('data-target')).slideToggle(300);
		  $(this).parents('.people-list--item').css('z-index', 1)
		  	.removeClass('active');
		});
  }

}
